import { __decorate } from "tslib";
import { Injectable } from "@angular/core";
import { HttpClient } from '@angular/common/http';
import { map, switchMap } from "rxjs";
import { ApiModuleConstants } from "src/app/shared/constants/api-constants/api-module.constants";
import { OrganisationModuleService } from "../../organisations/organisation-modules/service/organisation-module.service";
let NavToolbarContentService = class NavToolbarContentService {
    http;
    organisationModuleService;
    constructor(http, organisationModuleService) {
        this.http = http;
        this.organisationModuleService = organisationModuleService;
    }
    getHelpFile(moduleId) {
        const url = `${ApiModuleConstants.URL}/${moduleId}/${ApiModuleConstants.FUNCTION_GET_HELP_FILE}`;
        return this.http.get(url, { responseType: "blob" });
    }
    getHelpFileWithFileName(moduleId) {
        return this.organisationModuleService.getHelpFileInformation(moduleId).pipe(switchMap(attachment => {
            return this.getHelpFile(moduleId).pipe(map(response => {
                return {
                    fileName: attachment.fileName,
                    blob: response
                };
            }));
        }));
    }
    getHelpFileInformation(moduleId) {
        return this.http.get(`${ApiModuleConstants.URL}/${moduleId}/${ApiModuleConstants.FUNCTION_GET_HELP_FILE_INFORMATION}`);
    }
    static ctorParameters = () => [
        { type: HttpClient },
        { type: OrganisationModuleService }
    ];
};
NavToolbarContentService = __decorate([
    Injectable({ providedIn: "root" })
], NavToolbarContentService);
export { NavToolbarContentService };
